// extracted by mini-css-extract-plugin
module.exports = {"label":"mui_checkbox_form-control-label_label__3d0px"};